import React from 'react';

import { ColumnProps, InputType, RowProps } from '@/types/general';
import { CustomConfigInputV2 } from '@/components/core/custom-config-input-v2';

export function getGamesJurisdictionsTableData({
  gameData,
  gameIdList = [],
  setGameData,
}: {
  gameData: any[];
  gameIdList?: string[];
  setGameData: React.Dispatch<React.SetStateAction<any[]>>;
}): RowProps[] {
  const listData: RowProps[] = gameData?.map((item) => {
    gameIdList.push(item.jdCode);

    const columns: ColumnProps[] = [
      {
        type: {
          text: { content: item.jdTitle?.['en'] },
        },
      },
      {
        type: {
          text: { content: item.jdCode },
        },
      },

      {
        type: {
          component: (
            <CustomConfigInputV2
              label=""
              type={InputType.CHECKBOX}
              name=""
              value=""
              defaultData={gameData}
              setDefaultData={setGameData}
              numberProps={{
                isPercentage: true,
              }}
            />
          ),
        },
      },
      {
        type: {
          component: (
            <CustomConfigInputV2
              label=""
              type={InputType.CHECKBOX}
              name=""
              value=""
              defaultData={gameData}
              setDefaultData={setGameData}
              numberProps={{
                isPercentage: true,
              }}
            />
          ),
        },
      },
      {
        type: {
          component: (
            <CustomConfigInputV2
              direction="row"
              label=""
              trueLabel="Active"
              falseLabel="Active"
              type={InputType.CHECKBOX}
              name=""
              value=""
              defaultData={gameData}
              setDefaultData={setGameData}
            />
          ),
        },
      },
    ];

    return {
      id: item.jdCode,
      row: columns,
    };
  });

  return listData;
}
